import { Component } from '@angular/core';

@Component({
  selector: 'app-water-standards',
  standalone: false,
  templateUrl: './water-standards.component.html',
  styleUrl: './water-standards.component.scss'
})
export class WaterStandardsComponent {
   waterUrl: string = 'https://surface-prod.crm.dynamics.com/main.aspx?appid=a84f05c8-7109-f011-bae4-6045bd084d01&pagetype=entitylist&etn=new_waterdisposalstandards&viewid=ad370ca1-5d84-4300-bf8b-0cfc65dcd836&viewType=1039&lid=1744102046586';
}
